/**
 * @param e KeyboardEvent
 */
export const isBackspaceKeyCode = (e) => {
  return e.keyCode === 8
}

/**
 * @param e KeyboardEvent
 */
export const isDeleteKeyCode = (e) => {
  return e.keyCode === 46
}

/**
 * @param e KeyboardEvent
 */
export const isLengthKeyCode = (e) => {
  return isNumericKey(e) || isCommaKey(e) || isPeriodKey(e) || isSpace(e) || isSlash(e) || e.key === "'" || e.key === "\""
}

/**
 * @param e KeyboardEvent
 */
export const isNumericKey = (e) => {
  return (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)
}

/**
 *  is ","
 * @param e KeyboardEvent
 */
export const isCommaKey = (e) => {
  return e.keyCode === 188
}

/**
 *  is "."
 * @param e KeyboardEvent
 */
export const isPeriodKey = (e) => {
  return e.keyCode === 190
}

/**
 *  is " "
 * @param e KeyboardEvent
 */
export const isSpace = (e) => {
  return e.keyCode === 32
}

/**
 *  is "/"
 * @param e KeyboardEvent
 */
export const isSlash = (e) => {
  return e.keyCode === 191
}

/**
 * TODO check if this works on MAC
 * @param e
 * @return {*|boolean}
 */
export const isUndoKeyCode = (e) => {
  return (e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'Z' || e.keyCode === 90);
};
